import { Box, Card, Grid, Typography } from '@mui/material';

export const Section: React.FC<{
  title?: string;
  description?: string | React.ReactNode;
  children: React.ReactNode;
  colSize?: number;
  vertical?: boolean;
  spaceBetween?: boolean;
}> = ({ colSize = 3, children, description, title, vertical }) => {
  // Vertical layout
  if (vertical) {
    return (
      <Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flex: 1,
            mb: 1,
          }}
        >
          {title && <Typography variant="h5">{title}</Typography>}
          {description && <Box sx={{ ml: 'auto' }}>{description}</Box>}
        </Box>
        <Card sx={{ p: 3 }}>{children}</Card>
      </Box>
    );
  }

  // Horizontal layout (default)
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={colSize}>
        {title && (
          <Typography variant="h5" mb={0.5}>
            {title}
          </Typography>
        )}
        {description}
      </Grid>

      <Grid item xs={12} md={12 - colSize} gap={2}>
        <Card sx={{ p: 3 }}>{children}</Card>
      </Grid>
    </Grid>
  );
};

export default Section;
